import "./OurPhilosophy.css";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import CallToActionBlock from "../../../components/callToActionBlock/CallToActionBlock";
import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";
import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";
import PhilosophyInfoCard from "./philosophyInfoBlock/PhilosophyInfoCard";

const OurPhilosophy = () => {
  const { t } = useTranslation("translation", { keyPrefix: "ourPhilosophy" });
  const [activeCard, setActiveCard] = useState(0);

  const cards = [
    { title: "leadership", text: "leadershipContent" },
    { title: "ownImproving", text: "ownImprovingContent" },
    { title: "growingTogether", text: "growingTogetherContent" },
  ];

  const callToActionBlockStyles = {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    maxWidth: "100%",
  };

  const showPreviousCard = () => {
    setActiveCard((current) => (current - 1 + cards.length) % cards.length);
  };

  const showNextCard = () => {
    setActiveCard((current) => (current + 1) % cards.length);
  };

  return (
    <section className="philosophy" id="philosophy">
      <div className="philosophy__heading">
        <span className="philosophy__eyebrow">ACTIVE GENERATION</span>
        <h2 className="philosophyTitle">{t("title")}</h2>
      </div>

      <div className="philosophySlider">
        <div
          className="philosophySlider__track"
          style={{ transform: `translateX(-${activeCard * 100}%)` }}
          aria-live="polite"
        >
          {cards.map((card, index) => (
            <PhilosophyInfoCard
              key={card.title}
              title={card.title}
              text={card.text}
              index={index + 1}
              total={cards.length}
              isActive={index === activeCard}
            />
          ))}
        </div>

        <div className="philosophySlider__controls">
          <button
            className="philosophySlider__arrow"
            type="button"
            onClick={showPreviousCard}
            aria-label="Попередня картка"
          >
            <ArrowBackRoundedIcon />
          </button>

          <div className="philosophySlider__pagination" aria-label="Навігація картками">
            {cards.map((card, index) => (
              <button
                key={card.title}
                className={`philosophySlider__dot${index === activeCard ? " philosophySlider__dot--active" : ""}`}
                type="button"
                onClick={() => setActiveCard(index)}
                aria-label={`Перейти до картки ${index + 1}`}
                aria-current={index === activeCard ? "true" : undefined}
              />
            ))}
          </div>

          <button
            className="philosophySlider__arrow"
            type="button"
            onClick={showNextCard}
            aria-label="Наступна картка"
          >
            <ArrowForwardRoundedIcon />
          </button>
        </div>
      </div>

      <div className="philosophyContent__call-to-action">
          <CallToActionBlock
            attachmentBlock={"PhilosophyBlock"}
            blockStyles={callToActionBlockStyles}
          />
      </div>
    </section>
  );
};

export default OurPhilosophy;
